import { useEffect } from "react";
import { withRouter } from "react-router-dom";
import useGoogleAnalytics from "../../hooks/useGoogleAnalytics";
import useIpAddress from "../../hooks/useIpAddress";
import useLogging from "../../hooks/useLogging";
import Cookies from "universal-cookie";

function ScrollToTop({ history }) {
  // useIpAddress()
  useLogging();
  useGoogleAnalytics();
  useEffect(() => {
    const unlisten = history.listen(() => {
      const cookies = new Cookies();
      const isFoundUserMSISDN =
        cookies.get("userMSISDN") || localStorage.getItem("userMSISDN");
      if (!isFoundUserMSISDN) {
        [
          "local",
          "international",
          "africa",
          "othersports",
          "meloukelkora",
          "fitness",
        ].forEach((cookieKey) => cookies.remove(cookieKey));
      }
      window.scrollTo(0, 0);
    });
    return () => {
      unlisten();
    };
  }, []);

  return null;
}

export default withRouter(ScrollToTop);
